
import { Routes } from '@angular/router';
import { DefaultRoutes } from '@app/common/default-routes';
import { WPLIGHT_ROUTE_CONFIG } from '@app/common/default-light-route-config';

export const Demo_CUSTOM_ROUTE_CONFIG: Routes = [
 DefaultRoutes.USER,
 ...WPLIGHT_ROUTE_CONFIG,
 DefaultRoutes.MSTEAMS_AUTH,
];
